let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4IreQ")).then(() => parcelRequire('fqMF8'));